var exports = {
  "q": "x31de4314--189435--skeleton-item",
};

module.exports = exports;
